<!-- -------New Html (no-account manager added)------------ -->
<div class="not_added" *ngIf="emptyMsg">
    <div class="user_img"><img src="./assets/img-new/default_user.png" alt="user"></div>
    <h4>No site incharge added yet</h4>
    <button mat-raised-button color="primary" (click)="addClients()">
      <span class="sprite_icon plus_white"></span>
      <span>Add Site Incharge</span>
    </button>
  </div>

  <!----------New html of account manager listing-------------->
  <div *ngIf="showList">
    <div class="breadcrumb_outer">
      <ul class="breadcrumb">
        <li class="active"><a>Site Incharge</a></li>
      </ul>
      <div class="right"><span>{{today}}</span></div>
    </div>
    <div class="tag_powered_by">
      <span>Powered by: <b>Enertics</b></span>
    </div>
    <div class="Content_outer">
      <div class="content_view">
        <div class="row">
          <div class="col-md-12">
            <div class="listing_outer acc_manager">
              <div class="filter_div">
                <div class="top">
                  <h4>Site Incharge</h4>
                  <div class="right">
                    <div class="custom_search width_250">
                      <span class="sprite_icon search"></span>
                      <input type="text" class="form-control" placeholder="Search"  (input)="searchData($event.target.value)">
                    </div>
                    <button mat-raised-button color="primary" (click)="addClients()">
                      <span class="sprite_icon plus_white"></span>
                      <span>Add Site Incharge</span>
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="showEmptyError !== ''" class="no_result" >
                <p>{{showEmptyError}}</p>
              </div>

              <div class="listing_box" *ngFor="let clients of allManager;let idx = index;">
                <div class="left">
                  <div class="img_outer">
                    <img src="{{imageBaseV2Url}}{{clients.image}}" onerror="this.src='assets/img-new/client.png';">
                  </div>
                  <div class="details">
                    <h4>{{clients.full_name}}</h4>
                    <h6><span>
                        <img *ngIf="clients.country === 'India'" src="./assets/img-new/ind_flag.png" alt="India"
                          class="m_r_5">
                        <img *ngIf="clients.country === 'Canada'" src="./assets/img-new/flag.png" alt="India"
                          class="m_r_5">
                      </span>{{clients.country}}
                    </h6>
                  </div>
                </div>
                <div class="actions dropdown">
                  <button class="btn dropdown-toggle" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown">
                    <span class="sprite_icon ellipse_black"></span>
                  </button>
                  <mat-menu #menu="matMenu">
                    <div class="client_action">
                      <div class="menu-item-container">
                        <button mat-stroked-button color="primary" (click)="editClient(clients.id)" class="edit-button stroked-menu-button">
                          <mat-icon>edit</mat-icon>
                          <span>Edit</span>
                        </button>
                      </div>
                      <div class="menu-item-container">
                        <button mat-stroked-button color="warn" (click)="showDeleteDialog(clients.id, idx)" class="delete-button stroked-menu-button">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ---------------- -->